import { Content } from "antd/es/layout/layout";
import { useCallback, useEffect } from "react";
import { Layout } from "antd";
import PillNavbar from "../../../components/common/pillnav";
import { Outlet } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../../../store/slices/userSlice";

const Settings = () => {
  const dispatch = useDispatch();
  const getData = useCallback(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const userData = useSelector((state) => state.user.response);

  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <div>
      <Layout className="bg-white">
        <div className="w-full px-3 py-2">
          <PillNavbar />
        </div>
        <Layout>
          <Content className="w-full overflow-auto p-0 bg-white over">
            <div className=" bg-white">
              <Outlet context={userData} />
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
export default Settings;
